import { render, staticRenderFns } from "./ZjxxbglrEdit.vue?vue&type=template&id=0fc75392"
import script from "./ZjxxbglrEdit.vue?vue&type=script&lang=js"
export * from "./ZjxxbglrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports